// Test Data ---
// let BASEURL = 'https://leasing.pro360dev.freemyip.com'
// let FINANCE_URL = 'https://api.apps.rabahrain.com'
// Live Data ---
let BASEURL = 'https://pmkleaseapi.apps.pro360erp.com'
let FINANCE_URL = 'https://api.pro360erp.com'
export const endPoint = {

    GET_UNITNO_DATA: `${BASEURL}/api/LeaseCommon/GetCommonData`,
    GET_CUSTOMER_LAZY_NAME: `${BASEURL}/api/LeaseCommon/GetCustomersByName`,
    GET_CURRENCY_PER: `${FINANCE_URL}/api/finance/currencies/listing`,

    // Dashboard
    GET_DASHBOARD_LIST: `${BASEURL}/api/LeaseDashboard/GetDashboardUnits`,
    GET_DASHBOARD_DROP: `${BASEURL}/api/LeaseDashboard/GetMultipleDropdown`,
    GET_DASHBOARD_CASCAD: `${BASEURL}/api/LeaseDashboard/GetCascadDropdown`,
    GET_DASHBOARD_STATS: `${BASEURL}/api/LeaseDashboard/GetDashboardStats`,

    // Customer Master
    GET_CUSTOMER: `${BASEURL}/api/Customer/Get`,
    POST_CUSTOMER: `${BASEURL}/api/Customer/CreateCustomer`,
    DELETE_CUSTOMER: `${BASEURL}/api/Customer/GetCommonData`,
    EDIT_CUSTOMER: `${BASEURL}/api/Customer/EditCustomer`,
    CUSTOMER_CASCAD: `${BASEURL}/api/Customer/GetCascadDropdown`,
    CUSTOMER_COMMON: `${BASEURL}/api/Customer/GetCommonData`,
    CUSTOMER_MULTI: `${BASEURL}/api/Customer/GetMultipleDropdown`,

    // Unit Master
    GET_UNIT_LIST: `${BASEURL}/api/UnitManagement/GetAll`,
    GET_UNIT_ID: `${BASEURL}/api/UnitManagement/GetById/`,
    GET_UNIT_MULTIDROP: `${BASEURL}/api/UnitManagement/GetMultipleDropdown`,
    GET_UNIT_CASCAD: `${BASEURL}/api/UnitManagement/GetCascadDropdown`,
    CREATE_UNIT: `${BASEURL}/api/UnitManagement/Create`,
    UPDATE_UNIT: `${BASEURL}/api/UnitManagement/Update`,
    DELETE_UNIT: `${BASEURL}/api/UnitManagement/Delete/`,
    GET_UNIT_COMMON: `${BASEURL}/api/UnitManagement/GetCommonData`,
    POST_UNIT_ADDITIONAL: `${BASEURL}/api/UnitManagement/InsertAllAdditionalDetails`,

    // Property Master
    GET_PROPERTY_LIST: `${BASEURL}/api/Property/GetAll`,
    POST_PROPERTY: `${BASEURL}/api/Property/CreateProperty`,
    UPDATE_PROPERTY: `${BASEURL}/api/Property/EditProperty`,
    PROPERTY_MULTIDROP: `${BASEURL}/api/Property/GetMultipleDropdown`,
    PROPERTY_CASCAD: `${BASEURL}/api/Property/GetCascadDropdown`,
    PROPERTY_COMMON_DATA: `${BASEURL}/api/Property/GetCommonData`,
    DELETE_PROPERTY: `${BASEURL}/api/Property/DeleteProperty`,
    GET_PROPERTY_BY_ID: `${BASEURL}/api/Property/GetPropertyById`,
    UPLOAD_PROPERTY_IMAGE: `${BASEURL}/api/Property/AddPropertyImage`,
    DELETE_PROPERTY_IMAGE: `${BASEURL}/api/Property/DeletePropertyImage`,
    GET_PROPERTY_IMAGE: `${BASEURL}/api/Property/GetPropertyImages`,
    
    // File Upload
    UNIT_FILE: `${BASEURL}/api/FileUpload/unit-files`,
    GET_FILE: `${BASEURL}/api/FileUpload/list`,
    DELETE_FILE: `${BASEURL}/api/FileUpload/delete`,

}
